// extracted by mini-css-extract-plugin
export default {"NavLink":"MenuItem_NavLink__DJXnP","Active":"MenuItem_Active__DIvn0"};